export const SporFieldLabels = {
  requesterName: 'Requester Name',
  requesterPhoneNumber: 'Requester Phone Number',
  requesterDepartment: 'Requester Department',
  supplierId: 'Supplier',
  quote: 'Order Quote',
  attachments: 'Attachments',
  taxes: 'Taxes',
  fees: 'Fees',
  shipping: 'Shipping',
  totalCost: 'Total Cost',
  orderDate: 'Order Date',
  taskFiles: 'Document References'
} as const;

export type SporField = keyof typeof SporFieldLabels;

export const SporFields: SporField[] = Object.keys(
  SporFieldLabels
) as SporField[];
